/**
 * @generated SignedSource<<409d0abcdb02e7ce9289fdb4d633c4fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TopicHeaderRefreshedQuery$variables = {
  tagUuid: string;
};
export type TopicHeaderRefreshedQuery$data = {
  readonly tagByUuid: {
    readonly name: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"MetaActionsForTopic" | "TopicName_data" | "TopicTabs">;
  } | null;
};
export type TopicHeaderRefreshedQuery = {
  response: TopicHeaderRefreshedQuery$data;
  variables: TopicHeaderRefreshedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tagUuid"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "tagUuid"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TopicHeaderRefreshedQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tagByUuid",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "TopicName_data"
          },
          {
            "kind": "FragmentSpread",
            "name": "MetaActionsForTopic"
          },
          {
            "kind": "FragmentSpread",
            "name": "TopicTabs"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopicHeaderRefreshedQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tagByUuid",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "uuid"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "watching"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "d260f7a900b11a2c05e0e7247ec9120c",
    "id": null,
    "metadata": {},
    "name": "TopicHeaderRefreshedQuery",
    "operationKind": "query",
    "text": "query TopicHeaderRefreshedQuery(\n  $tagUuid: UUID!\n) {\n  tagByUuid(uuid: $tagUuid) {\n    name\n    ...TopicName_data\n    ...MetaActionsForTopic\n    ...TopicTabs\n    id\n  }\n}\n\nfragment MetaActionsForTopic on Tag {\n  uuid\n  ...TagFollowButton\n}\n\nfragment TagFollowButton on Tag {\n  id\n  uuid\n  name\n  watching\n}\n\nfragment TopicName_data on Tag {\n  uuid\n  name\n}\n\nfragment TopicTabs on Tag {\n  uuid\n}\n"
  }
};
})();

(node as any).hash = "f5ba8f44390545e3a087be7415aad99a";

export default node;
